// theme/index.js
import { createTheme, ThemeProvider } from '@mui/material/styles';

const theme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1200,
            xl: 1536,
            customBreakpoint: 1100, // Custom breakpoint
        },
    },
});

export default theme;
